import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, FormGroup, Form } from 'react-bootstrap';
import { Alert, Button, Icon } from '@storable/canaveral-components';
import EditableRichText from '../../../../../../src/web/containers/EditableRichText';
import MediaGalleryImage from '../../../../../../modules/react/components/stateful/MediaGalleryImage';
import { INPUT_PERMITTED_IMAGES_TYPES } from '../../../../../../modules/assets';
import styles from './styles.scss';


const propTypes = {
  altTextControlChange: PropTypes.func.isRequired,
  onRemoveImage: PropTypes.func.isRequired,
  onControlChange: PropTypes.func.isRequired,
  onCheckboxChange: PropTypes.func.isRequired,
  onTextEditorFinish: PropTypes.func.isRequired,
  popupHeaderText: PropTypes.string.isRequired,
  popupBodyContent: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  popupIncludeForm: PropTypes.bool.isRequired,
  popupButtonText: PropTypes.string.isRequired,
  medium: PropTypes.object,
  loading: PropTypes.string,
  formError: PropTypes.string,
  onUpload: PropTypes.string.isRequired,
  popupImageAltText: PropTypes.string.isRequired,
  popupImageTitleText: PropTypes.string.isRequired,
  setShowGallery: PropTypes.func.isRequired,
};

const defaultProps = {
  medium: undefined,
  loading: undefined,
  formError: undefined,
};

const attrs = [
  'onFeaturedImageChange',
  'altTextControlChange',
  'onRemoveImage',
  'onControlChange',
  'onCheckboxChange',
  'onTextEditorFinish',
  'featuredImage',
  'popupHeaderText',
  'popupBodyContent',
  'popupIncludeForm',
  'popupButtonText',
  'popupImageAltText',
  'popupImageTitleText',
  'medium',
  'loading',
  'onUpload',
  'formError',
  'setShowGallery',
];

const PopupFields = ({
  onTextEditorFinish,
  onCheckboxChange,
  altTextControlChange,
  onRemoveImage,
  onControlChange,
  popupHeaderText,
  popupBodyContent,
  popupIncludeForm,
  popupButtonText,
  popupImageAltText,
  popupImageTitleText,
  medium,
  loading,
  onUpload,
  formError,
  setShowGallery,
}) => {
  const uploadRef = useRef();

  /* const images = featuredImage && [{ mediumId: featuredImage }]; */

  return (
    <Row>
      <Col xs={12}>
        <FormGroup className={styles.FormGroup}>
          <label htmlFor="featuredImage">Featured Image</label>
          <div className={styles.buttonContainer}>
            <Button
              className={styles.button}
              context="neutral"
              icon="upload"
              onClick={() => uploadRef.current.click()}
              disabled={loading}
            >
              Upload Image
            </Button>
            <Button
              className={styles.button}
              context="neutral"
              disabled={loading}
              icon="images"
              onClick={() => setShowGallery(true)}
            >
              Select from Gallery
            </Button>
            <input
              accept={INPUT_PERMITTED_IMAGES_TYPES}
              className={styles.uploadInput}
              ref={uploadRef}
              type="file"
              onChange={onUpload}
            />
            {medium
              && (
                <div className={styles.imagePreview}>
                  <div className={styles.innerImagePreview}>
                    <Row>
                      {formError && (
                      <Alert className={styles.alert} context="danger">
                        <Icon id="warning" context="danger" label="error" />
                        <span className={styles.alertText}>{formError}</span>
                      </Alert>
                      )}
                      <Col xs={4}>
                        <MediaGalleryImage medium={medium} className={styles.innerImage} />
                      </Col>
                      <Col xs={8}>
                        <FormGroup>
                          <label htmlFor="popupHeaderText">Alt Text<span> *</span></label>
                          <Form.Control
                            name="popupImageAltText"
                            value={popupImageAltText}
                            onChange={altTextControlChange}
                            required
                          />
                        </FormGroup>
                        <FormGroup>
                          <label htmlFor="popupHeaderText">Title Text</label>
                          <Form.Control
                            name="popupImageTitleText"
                            value={popupImageTitleText}
                            onChange={onControlChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button context="neutral" onClick={onRemoveImage}>
                      <Icon id="trash" context="danger" />
                    </Button>
                  </div>
                </div>
              )}
          </div>
        </FormGroup>
        <FormGroup className={styles.FormGroup}>
          <label htmlFor="popupHeaderText">Header Text</label>
          <Form.Control
            name="popupHeaderText"
            value={popupHeaderText}
            onChange={onControlChange}
            required
          />
        </FormGroup>
        <FormGroup className={styles.FormGroup}>
          <label htmlFor="popupBodyContent">Body Text</label>
          <EditableRichText
            editing
            editorKey="popup-builder-fields"
            rawContentState={popupBodyContent}
            onChange={rawContentState => onTextEditorFinish({ name: 'popupBodyContent', rawContentState })}
          />
        </FormGroup>
        <FormGroup className={styles.FormGroup}>
          <label htmlFor="popupIncludeForm">Form Fields</label>
          <Form.Check type="checkbox" className="font-weight-normal" name="popupIncludeForm" onChange={onCheckboxChange} checked={popupIncludeForm} label="Include Form Fields" />
        </FormGroup>
        <FormGroup>
          <label htmlFor="popupButtonText">Button Text</label>
          <Form.Control
            name="popupButtonText"
            value={popupButtonText}
            onChange={onControlChange}
            required
          />
        </FormGroup>
      </Col>
    </Row>
  );
};

PopupFields.propTypes = propTypes;
PopupFields.defaultProps = defaultProps;
PopupFields.attrs = attrs;

export default PopupFields;
